<template>
  <div class="table-responsive">
    <table class="table table-flush">
      <thead class="thead-light">
        <tr>
          <th>Image</th>
          <th>Name (First Last)</th>
          <th>Ready to work Date</th>
          <th>Badges</th>
          <th class="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!potentialees[0]">
          <td align="center" colspan="100%">None found</td>
        </tr>
        <tr v-for="potentialee of potentialees" :key="potentialee.id">
          <td>
            <img class="img-fluid rounded" height="40px" :src="getImageUrl(potentialee.id)" />
          </td>
          <td>{{ potentialee.firstName }} {{ potentialee.lastName }}</td>
          <td>{{ formatDate(potentialee.readyToWorkDate) }}</td>
          <td class="p-2">
            <img
              height="40px"
              v-for="badgeId of potentialee.badgeIds"
              :key="badgeId"
              :src="getBadgeUrl(badgeId)"
            />
          </td>
          <td class="text-center">
            <button
              data-toggle="modal"
              data-target="#viewPotentialeeStats"
              @click="$parent.viewingPotentialee = potentialee"
              type="button"
              class="btn btn-sm btn-dark btn-icon-only rounded-circle mt-1"
              v-if="curOrg.type !== 'employer'"
            >
              <i class="fa fa-calculator"></i>
            </button>
            <button
              data-toggle="modal"
              data-target="#viewPotentialee"
              @click="$parent.viewingPotentialee = potentialee"
              type="button"
              class="btn btn-sm btn-dark btn-icon-only rounded-circle mt-1"
            >
              <i class="fa fa-eye"></i>
            </button>
            <button
              data-toggle="modal"
              data-target="#viewPotentialeeLists"
              @click="$parent.viewingPotentialee = potentialee"
              type="button"
              class="btn btn-sm btn-info btn-icon-only rounded-circle mt-1"
            >
              <i class="fa fa-list"></i>
            </button>
            <button
              data-toggle="modal"
              data-target="#contactPotentialee"
              @click="$parent.viewingPotentialee = potentialee"
              type="button"
              class="btn btn-sm btn-primary btn-icon-only rounded-circle mt-1"
              v-if="curOrg.type === 'employer'"
            >
              <i class="fa fa-id-card"></i>
            </button>
            <button
              data-toggle="modal"
              data-target="#editPotentialee"
              @click="$parent.editingPotentialee = potentialee"
              type="button"
              class="btn btn-sm btn-warning btn-icon-only rounded-circle mt-1"
              v-if="hasRoles(['potentialeeChange']) && curOrg.type !== 'employer'"
            >
              <i class="fa fa-pen"></i>
            </button>
            <button
              @click="deletePotentialee(potentialee)"
              type="button"
              class="btn btn-sm btn-danger btn-icon-only rounded-circle mt-1"
              v-if="hasRoles(['deletePotentialee']) && curOrg.type !== 'employer'"
            >
              <i class="fa fa-trash"></i>
            </button>
          </td>
        </tr>
        <tr>
          <td class="p-0"></td>
          <td class="p-0"></td>
          <td class="p-0"></td>
          <td class="p-0"></td>
          <td class="p-0"></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
window.$ = window.jQuery = require("jquery");
import firebase from "@/config/firebase.js";
import { firestorage } from "@/config/firebase.js";
require("bootstrap/dist/js/bootstrap.js");

import swal from "sweetalert2";

export default {
  name: "potentialees-table",
  props: {
    potentialees: Array
  },
  methods: {
    formatDate(date) {
      if (date) {
        const monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ];
        const dateObj = new Date(date.seconds * 1000);

        const month = monthNames[dateObj.getMonth()];
        const day = dateObj.getDate();
        const year = dateObj.getFullYear();

        return `${month} ${day}, ${year}`;
      }

      return "No date set";
    },
    getBadgeUrl(badgeId) {
      const base =
        "https://firebasestorage.googleapis.com/v0/b/potential-5635b.appspot.com/o/";
      return `${base}badges%2F${badgeId}%2Fimages%2Fbadge_100x100.png?alt=media`;
    },
    getImageUrl(potentialeeId) {
      const base =
        "https://firebasestorage.googleapis.com/v0/b/potential-5635b.appspot.com/o/";
      return `${base}potentialees%2F${potentialeeId}%2Fimages%2Fprofile_100x100.png?alt=media#${Date.now()}`;
    },
    hasRoles: function(roles) {
      return roles.every(this.hasRole);
    },
    hasRole: function(role) {
      return this.rolesData[role] != null || this.isOwner;
    },
    deletePotentialee(potentialee) {
      const curOrgId = this.curOrg.id;
      const self = this;

      swal
        .fire({
          title: "Are you sure?",
          text: `You are about to delete ${potentialee.firstName} ${potentialee.lastName}!`,
          type: "warning",
          icon: "warning",
          showCancelButton: !0,
          confirmButtonColor: "#0CC27E",
          cancelButtonColor: "#FF586B",
          confirmButtonText: "Continue",
          cancelButtonText: "Cancel",
          confirmButtonClass: "btn btn-success mr-5",
          cancelButtonClass: "btn btn-danger",
          buttonsStyling: !1
        })
        .then(
          function(result) {
            if (result.value) {
              firebase
                .firestore()
                .doc(`organizations/${curOrgId}/potentialees/${potentialee.id}`)
                .delete()
                .then(() => self.$parent.currentPageRefresh())
                .catch(function(error) {
                  console.error(error);
                });
            }
          },
          function(t) {
            "cancel" === t &&
              swal("Cancelled", "Your file is safe :)", "error");
          }
        );
    }
  },
  computed: {
    curOrg() {
      return this.$store.state.usermain.curOrg;
    },
    currentUser() {
      return this.$store.state.usermain.currentUser;
    },
    isOwner() {
      return this.$store.state.usermain.isOwner;
    },
    rolesData() {
      return this.$store.state.usermain.rolesData;
    }
  }
};
</script>
